module.exports = __webpack_public_path__ + "static/media/chassi.b2652ac8.jpeg";